import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Button, darken } from "@mui/material";
import { Stack } from "@mui/system";
import { PDFDownloadLink } from "@react-pdf/renderer";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_VI } from "material-react-table/locales/vi";
import { useEffect, useMemo, useState } from "react";
import * as XLSX from "xlsx";
import PDFDownload from "../../components/PDFDownload/pdfDownload";

/* eslint-disable react/prop-types */
function CustomTableStatic({
  columns,
  data,
  count,
  pagination,
  setPagination,
  isLoading,
  isError,
  isRefetching,
  tableHeaders,
  tableKeyValues,
  filename,
  titleTable,
  colWidths,
  widthPercentPDF,
  orientaitionPage,
  subRow,
  allData,
  isUsingAllData,
  dicSizeBreakWord,
  ...props
}) {
  const [tableDataPDF, setTableDataPDF] = useState();
  useEffect(() => {
    if (tableKeyValues?.length > 0 && data?.length > 0 && allData?.length > 0) {
      let tableData = data.map((row, index) => {
        let defaultValue = row;
        let text = {};
        tableKeyValues?.forEach((key) => {
          text[key] = defaultValue[key];
        });
        return text;
      });
      const cloneTableData = allData?.map((row) => {
        let text = {};
        tableKeyValues?.forEach((key) => {
          text[key] = row[key];
        });
        return text;
      });
      const tableDataPDF = isUsingAllData
        ? [...cloneTableData]
        : [...tableData];
      setTableDataPDF(tableDataPDF);
    }
  }, [allData, data, isUsingAllData, tableKeyValues]);

  const handleExportDataExcel = (tableHeaders, tableData) => (e) => {
    var dataSheet = tableData?.map((item, index) => ({
      index: index + 1,
      ...item,
    }));
    if (dataSheet?.length > 0) {
      var heading = [["STT", ...tableHeaders]];
      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_aoa(ws, [[titleTable]], { origin: "A1" });
      XLSX.utils.sheet_add_aoa(ws, heading, { origin: "A2" });
      XLSX.utils.sheet_add_json(ws, dataSheet, {
        skipHeader: true,
        origin: "A3",
      });

      var newcolWidths = [];
      colWidths?.forEach((item) => newcolWidths.push({ wch: item }));
      ws["!cols"] = newcolWidths;
      XLSX.utils.book_append_sheet(wb, ws, filename);
      XLSX.writeFile(wb, `${filename}.xlsx`);
    }
  };
  const renderButtonDownload = useMemo(() => {
    const tableData = tableDataPDF;
    if (!isLoading && !isRefetching && tableData?.length > 0) {
      return (
        <PDFDownloadLink
          document={
            <PDFDownload
              tableHeaders={tableHeaders}
              tableData={tableData}
              widthPercentPDF={widthPercentPDF}
              title={titleTable}
              orientaitionPage={orientaitionPage}
              subRow={subRow}
              dicSizeBreakWord={dicSizeBreakWord}
            />
          }
          fileName={`${filename}.pdf`}
        >
          {(
            { blob, url, loading, error } // Render the button content based on the link status
          ) => (
            <Button
              startIcon={<FileDownloadIcon />}
              disabled={loading || tableData.length === 0}
            >
              PDF
            </Button>
          )}
        </PDFDownloadLink>
      );
    } else {
      return (
        <Button disabled={true} startIcon={<FileDownloadIcon />}>
          PDF
        </Button>
      );
    }
  }, [isLoading, isRefetching, tableDataPDF]);

  return (
    <MaterialReactTable
      muiToolbarAlertBannerProps={
        isError
          ? {
              color: "error",
              children: "Lỗi khi lấy dữ liệu",
            }
          : undefined
      }
      enableRowNumbers
      rowNumberMode="static"
      columns={columns}
      data={data}
      enableFilters={true}
      enableHiding={false}
      enableColumnOrdering={false}
      enableDensityToggle={true}
      enableColumnResizing
      manualPagination
      onPaginationChange={setPagination}
      rowCount={count}
      localization={MRT_Localization_VI}
      initialState={{
        isLoading: true,
        columnVisibility: {
          id: false,
        },
        density: "compact",
      }}
      state={{
        pagination,
        isLoading,
        showAlertBanner: isError,
        showProgressBars: isRefetching,
      }}
      muiTablePaperProps={{
        elevation: 0,
        sx: {
          borderRadius: "0",
          border: "1px solid rgb(211 225 245)",
          backgroundColor: "#fff",
        },
      }}
      muiTableBodyProps={{
        sx: (theme) => ({
          "& tr:nth-of-type(odd)": {
            backgroundColor: darken(theme.palette.background.default, 0.1),
          },
        }),
      }}
      // muiTableContainerProps={{
      //   sx: {
      //     maxHeight: "25rem",
      //   },
      // }}
      renderTopToolbarCustomActions={({ table }) => {
        let tableData = table
          ?.getPrePaginationRowModel()
          .rows.map((row, index) => {
            let defaultValue = row.original;
            let text = {};
            tableKeyValues?.forEach((key) => {
              text[key] = defaultValue[key];
            });
            return text;
          });
        const cloneTableData = allData?.map((row) => {
          let text = {};
          tableKeyValues?.forEach((key) => {
            text[key] = row[key];
          });
          return text;
        });
        tableData = isUsingAllData ? [...cloneTableData] : [...tableData];
        return (
          <Stack spacing={2} direction="row" color="white">
            <Button
              disabled={table.getPrePaginationRowModel().rows.length === 0}
              onClick={handleExportDataExcel(tableHeaders, tableData)}
              startIcon={<FileDownloadIcon />}
            >
              Excel
            </Button>
            {renderButtonDownload}
          </Stack>
        );
      }}
      {...props}
    />
  );
}

export default CustomTableStatic;
